export const MAX_UPLOAD_IMAGE_FILE_SIZE = 1000000; // 1MB